var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    tableBottomPadding: spacing === null || spacing === void 0 ? void 0 : spacing.medium,
    colorGray: colors === null || colors === void 0 ? void 0 : colors.tiara,
    cellPadding: "".concat(spacing === null || spacing === void 0 ? void 0 : spacing.small, " ").concat(spacing === null || spacing === void 0 ? void 0 : spacing.small)
  };
};
export default generateComponentTheme;